import React from 'react'
import styled from 'styled-components'
import { Popconfirm } from 'antd'
import { observer } from 'mobx-react-lite'
import { RightOutlined } from '@ant-design/icons'
import { useRouter } from 'next/router'

export interface SearchResultHeaderProps {
	keyword: string
	total: number
	onCart?: () => void
	goToCart?: () => void
	isModalOpen?: boolean
}

export const SearchResultHeader: React.FC<SearchResultHeaderProps> = observer(
	({ keyword, total, onCart, goToCart, isModalOpen }) => {
		const handleOnCart = () => {
			if (onCart) {
				onCart()
			}
		}
		const router = useRouter()
		// 수업자료일 때는 [수업자료 총 #건]
		// 교과서일 때는 [교과서 라이선스 총 #건]
		// 참고서일 때는 [참고서 라이선스 총 #건]
		const renderType = () => {
			let renderString: string
			const query = router.query
			switch (query.slug) {
				case 'textbook':
					renderString = '교과서'
					break
				case 'handout':
					renderString = '수업자료'
					break
				case 'workbook':
					renderString = '참고서'
					break
				default:
					renderString = '검색결과'
			}
			return renderString
		}

		return (
			<HeaderWrapper>
				<SearchTitle>
					{keyword && keyword !== '' ? (
						<>
							{/* eslint-disable-next-line react/no-unescaped-entities */}
							<span className="searchKeyword">'{keyword}'</span>
							<span className="searchResult">검색 결과</span>
						</>
					) : (
						<>
							{/* eslint-disable-next-line react/no-unescaped-entities */}
							<span className="searchResult">{renderType()}</span>
						</>
					)}

					<span className="searchResultValue">총 {total}건</span>
				</SearchTitle>
				<Popconfirm
					title="장바구니에 담았습니다."
					// open={addToCart}
					open={isModalOpen}
					onConfirm={goToCart}
					okButtonProps={{
						icon: <RightOutlined />,
						style: {
							display: 'flex',
							flexDirection: 'row-reverse',
							alignItems: 'center',
							color: 'black',
							backgroundColor: 'white',
						},
					}}
					cancelButtonProps={{ style: { display: 'none' } }}
					cancelText={null}
					okText="장바구니로 가기">
					{/*<Button size={'large'} type={'primary'} onClick={handleOnCart}>*/}
					{/*	장바구니에 담기*/}
					{/*</Button>*/}
				</Popconfirm>
			</HeaderWrapper>
		)
	},
)

const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 16px;
	border-bottom: solid 2px #1b1b29;

	.ant-btn {
		width: 160px;
		height: 48px;
		box-shadow: 0 4px 4px 0 rgba(51, 114, 117, 0.2);
		border-radius: 2px;
		background-color: #002fa8;

		&:hover {
			background-color: #113ac3;
		}

		span {
			display: block;
			font-size: 16px;
			font-weight: bold;
			color: #fff;
		}
	}

	@media (max-width: 1200px) {
		display: none;
	}
	@media (max-width: 768px) {
	}
`

const SearchTitle = styled.div`
	span {
		font-size: 24px;
		font-weight: bold;
		letter-spacing: -0.25px;
	}

	.searchKeyword {
		display: inline-block;
		vertical-align: baseline;
		color: #002fa8;
	}

	.searchResult {
		line-height: 1.5;
		margin-left: 4px;
		margin-right: 8px;
	}

	.searchResultValue {
		font-size: 16px;
		color: rgba(27, 27, 41, 0.3);
	}

	.searchNumber {
	}
`
